import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JustfoneDataTransferDebugService {

  servicePath: string = '/justfoneapi';

  get serviceBaseUrl(): string {
    var url = Location.joinWithSlash(this.environment.apiUrl, this.servicePath);
    url = Location.stripTrailingSlash(url);
    return url;
  }

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
  }

  public getEntityData(className: string, id: string): Observable<any> {
    var params = new HttpParams();
    params = appendSerialisedHttpParams(className, 'className', params);
    params = appendSerialisedHttpParams(id, 'id', params);
    return this.http.get<any>(this.serviceBaseUrl + '/debug', {params: params});
  }

  public forceCreateOrUpdateEntity(className: string, id: string): Observable<any> {
    var params = new HttpParams();
    params = appendSerialisedHttpParams(className, 'className', params);
    params = appendSerialisedHttpParams(id, 'id', params);
    return this.http.get<any>(this.serviceBaseUrl + '/update', {params: params});
  }

  public forceDeleteEntity(className: string, id: string): Observable<any> {
    var params = new HttpParams();
    params = appendSerialisedHttpParams(className, 'className', params);
    params = appendSerialisedHttpParams(id, 'id', params);
    return this.http.delete<any>(this.serviceBaseUrl + '/delete', {params: params});
  }
}